export default {

All:"All",
Vegetables:"Vegetables",
Fruits:"Fruits",
Fresh:"Fresh",
Meat:"Meat",
Dairy:"Dairy",
Bakery:"Bakery",
Beverages:"Beverages",

categories:"Categories",
size:"Size",
priceRange:"Price Range",
filterByVendor:"Filter by Vendor",
deliveryTrust:"Delivery & Trust",
sameDayDelivery:"Same Day Delivery",
verifiedSuppliers:"Verified Suppliers",
resetFilters:"Reset Filters",
selectStore:"Select Store Address",
Kg:"Kg",
Liter:"Liter",
Piece:"Piece",
Box:"Box",

viewProduct:"View Product",

minutes:"MIN",

buy:"BUY",
get:"GET",
off:"OFF",

qar:"QAR",

  "free_delivery": "Free Delivery Across Qatar",
  "verified_suppliers": "100% Verified Suppliers",
  "fast_processing": "Fast Order Processing",
  "download_app": "Download Mahal Mobile App"

}